"use client";
import { useEffect, useRef } from "react";

export const useEventListener = (
	eventName: string,
	handler: (event: Event) => void,
	element = window
) => {
	// Create a ref that stores handler
	const savedHandler = useRef<(event: Event) => void>(undefined);

	useEffect(() => {
		// Define the listening function
		const eventListener = (event: Event) => {
			if (savedHandler.current) {
				savedHandler.current(event);
			}
		};
		// Add the event listener
		element.addEventListener(eventName, eventListener);

		// Remove the event listener on cleanup
		return () => {
			element.removeEventListener(eventName, eventListener);
		};
	}, [eventName, element]);

	// Update ref.current value if handler changes
	useEffect(() => {
		savedHandler.current = handler;
	}, [handler]);
};
